<div class="row g-2">
  <div class="col-2 form-group">
    <label for="serviceCode"
      >Service Code
      <i
        class="info-icon ms-2"
        certTooltip="The service code supported by these voucher credits. If you do not see the desired service code, then please check this cycle's Eligibility Rules."
      ></i>
    </label>
    <ng-select
      id="serviceCode"
      name="serviceCode"
      [items]="serviceCodes"
      bindLabel="description"
      bindValue="id"
      [(ngModel)]="serviceCodeId"
      placeholder="Select Service Code"
    >
    </ng-select>
  </div>
  <div class="col-2 form-group">
    <label for="date-input-expiredDate"
      >Expire Date
      <i
        class="info-icon ms-2"
        certTooltip="The date on which this voucher credit expires. Voucher is valid 14 days prior to this expiration date."
      ></i>
    </label>
    <cert-date-input name="expiredDate" [(model)]="expiredDate" [propertyName]="'expiredDate'" />
  </div>
  <div class="col-2 my-auto">
    <span [certTooltip]="'Select a service code and an expire date'" [enableTooltip]="!serviceCodeId || !expiredDate">
      <button class="btn btn-primary" (click)="onSubmit()" [disabled]="disabled || !serviceCodeId || !expiredDate">
        Create Voucher Credits
      </button>
    </span>
  </div>
</div>
